import { Box, Grid, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Paper from '@mui/material/Paper';
import { colors } from 'constants/theme';
import _ from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { routeName } from 'routes/routes-name';

/** TRANSLATION*/
import HeaderLabel from 'component/CardCustom/HeaderLabel';
import { useTranslation } from 'react-i18next';

/** STYLE */
import TextField from '@mui/material/TextField';
import LabGroupsApi from 'api/setting/default-labs/lab-group.api';
import LabTypeApi from 'api/setting/default-labs/lab-type.api';
import LabsApi from 'api/setting/default-labs/lab.api';
import InputCheckbox from 'component/Input/InputCheckbox';
import { notiError, notiSuccess } from 'component/notifications/notifications';
import { icons } from 'constants/images';
import { BtnAdd, HeaderTable } from 'features/setting/default-labs/lab-group/style';
import SelectInput from 'new-components/inputs/select-input';
import TextInput from 'new-components/inputs/text-input';

interface LabsInterface {
  inputSupport: string
  labId: number
  labName: string
}

interface LabTypesInterface {
  labTypeId: number
  labTypeName: string
  labId: number
  labName: string
  inputSupport: string
}

interface LabTypesDisplayInterface {
  labTypeName: string
  labTypeId: number | null
  labTypes: LabTypesInterface[]
}

const initStateErrorMessage = {
  LAB_GROUP_NAME: '',
  LAB_GROUP_DUPLICATE: ''
}

export default function FormLabGroup() {
  const { t } = useTranslation()
  const location = useLocation()
  const history = useHistory()
  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
  const [labGroupId, setLabGroupId] = useState(Number)
  const [labGroupName, setLabGroupName] = useState('')
  const [labs, setLabs] = useState<LabsInterface[]>([])
  const [labTypesDisplay, setLabTypesDisplay] = useState<LabTypesDisplayInterface[]>([])
  const [loadLabTypes, setLoadLabTypes]: any = useState([])
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const submit = () => {
    setDisabledSubmit(true)
    const labtypedisplaydisplayTemp = labTypesDisplay
    const labGroupDetailsTemp: any = []
    for (const lab of labtypedisplaydisplayTemp) {
      if (lab.labTypes) labGroupDetailsTemp.push(...lab.labTypes)
    }
    const labGroupDetails: any = []
    _.map(labGroupDetailsTemp, (lab: any) => {
      if (lab.labName && lab.labTypeName)
        labGroupDetails.push({ labTypeId: lab.labTypeId, labTypeName: lab.labTypeName, labId: lab.labId, labName: lab.labName })
    })
    const objCreate = { labGroupName: labGroupName, status: 'ACTIVE', labGroupDetails: labGroupDetails }

    if (!labGroupName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, LAB_GROUP_NAME: t('LAB_GROUP.MESSAGE.LAB_GROUP_NAME') })
    }
    LabGroupsApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          setDisabledSubmit(false)
          notiSuccess(t('LAB_GROUP.MESSAGE.SUCCESS.CREATE'))
          history.push(routeName.labGroup)
        }
        else {
          setDisabledSubmit(false)
          const err = res.response.data
          if (err.message === 'IS_DUPLICATE_LAB_GROUP_NAME') {
            setErrorMessage({ ...errorMessage, LAB_GROUP_DUPLICATE: t(`LAB_GROUP.MESSAGE.${err.message}`) })
            return
          } else {
            notiError(t(`LAB_GROUP.MESSAGE.${err.message}`))
          }
        }
      })
      .catch((e) => {
        setDisabledSubmit(false)
        const err = e.response.data
        if (err.message === 'IS_DUPLICATE_LAB_GROUP_NAME') {
          setErrorMessage({ ...errorMessage, LAB_GROUP_DUPLICATE: t(`LAB_GROUP.MESSAGE.${err.message}`) })
          return
        } else {
          notiError(t(`LAB_GROUP.MESSAGE.${err.message}`))
        }
      })
  }

  const submitEdit = () => {
    setDisabledSubmit(true)
    const labtypedisplaydisplayTemp = labTypesDisplay
    const labGroupDetailsTemp: any = []
    for (const lab of labtypedisplaydisplayTemp) {
      labGroupDetailsTemp.push(...lab.labTypes)
    }
    const labGroupDetails: any = []
    _.map(labGroupDetailsTemp, (lab: any) => {
      if (lab.labName && lab.labTypeName)
        labGroupDetails.push({ labTypeId: lab.labTypeId, labTypeName: lab.labTypeName, labId: lab.labId, labName: lab.labName })
    })
    if (!labGroupName) {
      setDisabledSubmit(false)
      return setErrorMessage({ ...errorMessage, LAB_GROUP_NAME: t('LAB_GROUP.MESSAGE.LAB_GROUP_NAME') })
    }
    const objUpdate = { labGroupName: labGroupName, status: 'ACTIVE', labGroupDetails: labGroupDetails }

    LabGroupsApi.update(labGroupId, objUpdate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          setDisabledSubmit(false)
          notiSuccess(t(`LAB_GROUP.MESSAGE.SUCCESS.UPDATE`), '', null, () => {
            history.push(routeName.labGroup)
          })
        } else {
          setDisabledSubmit(false)
          const err = res.response.data
          if (err.message === 'IS_DUPLICATE_LAB_GROUP_NAME') {
            setErrorMessage({ ...errorMessage, LAB_GROUP_DUPLICATE: t(`LAB_GROUP.MESSAGE.${err.message}`) })
            return
          } else {
            notiError(t(`LAB_GROUP.MESSAGE.${err.message}`))
          }
        }
      })
      .catch((e) => {
        setDisabledSubmit(false)
        const err = e.response.data
        if (err.message === 'IS_DUPLICATE_LAB_GROUP_NAME') {
          setErrorMessage({ ...errorMessage, LAB_GROUP_DUPLICATE: t(`LAB_GROUP.MESSAGE.${err.message}`) })
          return
        } else {
          notiError(t(`LAB_GROUP.MESSAGE.${err.message}`))
        }
      })
  }

  const onEdit = (data: any) => {

    setLabGroupId(data.labGroupId)
    setLabGroupName(data.labGroupName)
    const labGroupDetailsTemp = data.labGroupDetails
    const labTypeFilted: any = []
    for (const lab of labGroupDetailsTemp) {
      if (!labTypeFilted.some((e: any) => e.labTypeName === lab.labTypeName)) {
        labTypeFilted.push({ labTypeName: lab.labTypeName, labTypeId: lab.labTypeId })
      }
    }
    const tempLabTypesDisplay = []
    for (const labItem of labTypeFilted) {
      const groupLabs = labGroupDetailsTemp.filter((lab: any) => lab.labTypeName === labItem.labTypeName)
      const labType = groupLabs.map((lab: any) => ({ labTypeId: lab.labTypeId, labTypeName: lab.labTypeName, labId: lab.labId, labName: lab.labName, inputSupport: lab.inputSupport }))
      tempLabTypesDisplay.push({ labTypeName: labItem.labTypeName, labTypeId: labItem.labTypeId, labTypes: labType })
    }
    setLabTypesDisplay(tempLabTypesDisplay)
  }

  const loadLabs = useCallback(async () => {
    const res = await LabsApi.findAllActive({})
    if (res.status === 200) {
      const lab: any = []
      for (const data of res.data)
        lab.push({ labName: data.labName, labId: data.labId, inputSupport: data.inputSupport })
      setLabs(lab)
    }
  }, [])

  const loadLabTypesAPI = useCallback(async () => {
    const res = await LabTypeApi.findAll({ status: 'ACTIVE', pageLimit: 100 })
    if (res.status === 200) {
      const labType: any = []
      for (const data of res.data) {
        labType.push({ labTypeId: data.labTypeId, labTypeName: data.labTypeName })
      }
      setLoadLabTypes(labType)
    }
  }, [])

  const loadLabsEdit = async (labTypeId: number, inputLabName: string) => {
    const res = await LabTypeApi.findLabs(labTypeId)
    const labsNew: any = []
    if (res.status === 200) {
      for (const data of res.data) {
        if (data.mapType !== null) {
          labsNew.push({ labName: data.labName, labId: data.labId, inputSupport: data.inputSupport, labTypeId: data.mapType.labTypeId, labTypeName: inputLabName })
        }
      }
    }
    return labsNew
  }

  const handleLabType = (labName: any, index: number, iLabDisplay: number, labDisplay: any) => {
    const labTypesDisplayTemp: any = [...labTypesDisplay]
    if (typeof labName === 'object') {
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labName = labName.labName
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labId = labName.labId
      labTypesDisplayTemp[iLabDisplay].labTypes[index].inputSupport = labName.inputSupport
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labTypeName = labDisplay.labTypeName
    } else {
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labTypeName = labTypesDisplayTemp[iLabDisplay]?.labTypeName
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labName = labName
      labTypesDisplayTemp[iLabDisplay].labTypes[index].labId = labDisplay.labId || null
      labTypesDisplayTemp[iLabDisplay].labTypes[index].inputSupport = labDisplay.inputSupport || "NOT_SUPPORT"
    }
    setLabTypesDisplay(labTypesDisplayTemp)
  }

  const handleSupportLabType = (checked: boolean, index: number, iLabDisplay: number) => {
    const labTypesDisplayTemp: any = [...labTypesDisplay]
    const check = checked === true ? 'SUPPORT' : 'NOT_SOPPORT'
    labTypesDisplayTemp[iLabDisplay].labTypes[index].inputSupport = check
    setLabTypesDisplay(labTypesDisplayTemp)
  }

  const handleDeleteLabDisplay = (index: number) => {
    const labTypesDisplayTemp = labTypesDisplay.filter((lab: any, iLab: number) => index !== iLab)
    setLabTypesDisplay(labTypesDisplayTemp)
  }

  const handleSelectTypeDisplay = (iLabDisplay: number, inputLabName: string) => {
    const index = loadLabTypes.findIndex((labType: any) => labType.labTypeName === inputLabName)
    const labTypesDisplayTemp = [...labTypesDisplay]
    if (index > 0) {
      loadLabsEdit(loadLabTypes[index].labTypeId, inputLabName).then((res) => {
        labTypesDisplayTemp[iLabDisplay].labTypes = res
        labTypesDisplayTemp[iLabDisplay].labTypeName = inputLabName
        labTypesDisplayTemp[iLabDisplay].labTypeId = loadLabTypes[index].labTypeId

        setLabTypesDisplay(labTypesDisplayTemp)
      })
    } else {
      labTypesDisplayTemp[iLabDisplay].labTypeName = inputLabName
      labTypesDisplayTemp[iLabDisplay].labTypeId = null
      setLabTypesDisplay(labTypesDisplayTemp)
    }
  }

  const handleAddLabsInLabTypesDisplay = (index: number, labDisplay: any) => {
    const labTypesDisplayTemp = [...labTypesDisplay]
    labTypesDisplayTemp[index].labTypes = [{ labName: '', labId: 1, inputSupport: 'NOT_SUPPORT', labTypeId: labDisplay.labTypeId, labTypeName: '' }, ...labTypesDisplayTemp[index].labTypes]
    setLabTypesDisplay(labTypesDisplayTemp)
  }

  const handleDeleteLabInLabTypesDisplay = (iLabDisplay: number, index: number) => {
    const labTypesDisplayTemp = [...labTypesDisplay]
    const labTypes = labTypesDisplay[iLabDisplay].labTypes.filter((lab: any, iLab: number) => index !== iLab)
    labTypesDisplayTemp[iLabDisplay].labTypes = labTypes
    setLabTypesDisplay(labTypesDisplayTemp)
  }

  useEffect(() => {
    if (location.state) {
      onEdit(location.state)
    }

    loadLabs()
    loadLabTypesAPI()
  }, [loadLabs, loadLabTypesAPI, location])
  return (
    <Box>
      <HeaderLabel
        text={labGroupId ? t('LAB_GROUP.TITLE_UPDATE') : t('LAB_GROUP.TITLE_CREATE')}
        navigator={{ previousTo: routeName.labGroup, previousTitle: t('LAB_GROUP.TITLE'), currentTitle: labGroupId ? t('LAB_GROUP.TITLE_UPDATE') : t('LAB_GROUP.TITLE_CREATE') }}
        goBack={routeName.labGroup}
        disabled={disabledSubmit}
        onSubmit={labGroupId ? submitEdit : submit}
      />
      <Box paddingX="24px">
        <Box boxShadow={3} width="100%" paddingX="32px" paddingY="24px">
          <Grid container>
            <Grid item sm={12} md={4}>
              <TextInput
                label={t('LAB_GROUP.INPUT.LAB_TYPE_NAME')}
                value={labGroupName}
                onChange={(e) => {
                  setErrorMessage(initStateErrorMessage)
                  setLabGroupName(e.target.value)
                }}
                fullWidth
                required
                helperText={errorMessage.LAB_GROUP_NAME || errorMessage.LAB_GROUP_DUPLICATE}
              />
            </Grid>
          </Grid>

          <Box width="100%">
            <Typography fontWeight={400} fontSize={16} paddingY="24px">
              {t('LAB_TYPE.LIST_TYPE_LAB')}
            </Typography>
            <BtnAdd variant='text'
              onClick={() => {
                setLabTypesDisplay([{ labTypeName: '', labTypeId: null, labTypes: [] }, ...labTypesDisplay])
              }}>+ {t('LAB_TYPE.BUTTON.ADD')}</BtnAdd>

            {labTypesDisplay.map((labDisplay: any, iLabDisplay: number) => {
              return (
                <Box paddingLeft="24px" key={iLabDisplay} paddingY="16px">
                  <Box display="flex" justifyContent="space-between" alignItems="center" paddingBottom="8px">
                    {/* <Autocomplete
                      id="grouped-demo"
                      style={{ width: '600px' }}
                      freeSolo
                      disableClearable
                      size={'small'}
                      options={loadLabTypes}
                      getOptionLabel={(option: any) => option.labTypeName}
                      fullWidth={true}
                      renderInput={(params) => <TextField {...params} label={t('LAB_TYPE.TYPE_LAB')} />}
                      inputValue={labDisplay.labTypeName}
                      onInputChange={(event, inputLabName) => {
                        if (event != null) {
                          handleSelectTypeDisplay(iLabDisplay, inputLabName)
                        }
                      }}
                    /> */}
                    <SelectInput
                      label={t('LAB_TYPE.TYPE_LAB')}
                      width={600}
                      options={loadLabTypes.map((item: any) => ({
                        value: item.labTypeId,
                        name: item.labTypeName,
                        disabled: labTypesDisplay.some((d: any, idx: number) => d.labTypeId === item.labTypeId && idx !== iLabDisplay
                        )
                      }))}
                      onChange={(e) => handleSelectTypeDisplay(iLabDisplay, e.target.name)}
                      value={labTypesDisplay[iLabDisplay]?.labTypeId || ''}
                    />
                    <IconButton
                      className={'btn-delete ml-auto'}
                      aria-label="delete"
                      onClick={(e) => {
                        handleDeleteLabDisplay(iLabDisplay)
                      }}
                      sx={{ backgroundColor: 'transparent !important', padding: 0 }}
                    >
                      <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                    </IconButton>
                  </Box>
                  <TableContainer component={Paper} style={{ boxShadow: 'none', marginTop: '4px', marginBottom: '8px' }}>
                    <Table aria-label="simple table">
                      <TableHead sx={{ backgroundColor: colors.themeMainColor }}>
                        <TableRow>
                          <TableCell key={'#'} align="center">
                            <HeaderTable color="white">#</HeaderTable>
                          </TableCell>
                          <TableCell key={'list-lab'} align="center">
                            <HeaderTable color="white">{t('LAB_GROUP.TABLE.CELL.LAB_NAME')}</HeaderTable>
                          </TableCell>
                          <TableCell key={'lab-remark'} align="center">
                            <HeaderTable color="white">{t('LAB_GROUP.TABLE.CELL.ADD_DATA')}</HeaderTable>
                          </TableCell>
                          <TableCell key={'lab-action'} align="center">
                            <HeaderTable color="white">Action</HeaderTable>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody >
                        <TableRow>
                          <TableCell
                            sx={{
                              borderRight: `1px solid ${colors.black20} !important`, borderLeft: `1px solid ${colors.black20} !important`,
                              cursor: 'pointer',
                              fontSize: '16px',
                              backgroundColor: '',
                              '&:hover': {
                                fontWeight: 600,
                                backgroundColor: `${colors.extraLightGray} !important`,
                              }
                            }}
                            onClick={() => {
                              handleAddLabsInLabTypesDisplay(iLabDisplay, labDisplay)
                            }}
                            colSpan={8}
                          >
                            <div style={{ color: colors.themeSecondColor }}>+ {t('LAB.BUTTON.ADD')}</div>
                          </TableCell>
                        </TableRow>
                        {labDisplay.labTypes.map((lab: any, index: any) => {
                          return (
                            <TableRow key={`${index}`} sx={{ borderRight: `1px solid ${colors.black20} !important`, borderLeft: `1px solid ${colors.black20} !important` }}>
                              <TableCell>{labDisplay.labTypes.length - index}</TableCell>
                              <TableCell>
                                <Autocomplete
                                  id="grouped-demo"
                                  freeSolo
                                  disableClearable
                                  size={'small'}
                                  options={labs}
                                  getOptionLabel={(option: any) => option.labName}
                                  renderOption={(props, option: any) => (
                                    <Box
                                      {...props}
                                      key={option.value}
                                      component="li"
                                      sx={{
                                        pointerEvents: _.some(labDisplay.labTypes, { labName: option?.labName }) ? 'none !important' : 'auto !important',
                                        opacity: _.some(labDisplay.labTypes, { labName: option?.labName }) ? .5 : 1
                                      }}>
                                      {option.labName}
                                    </Box>
                                  )}
                                  fullWidth={true}
                                  renderInput={(params) => <TextField {...params} label={t('LAB.TABLE.CELL.LIST_LAB')} />}
                                  inputValue={lab.labName}
                                  onChange={(e: any, v: any) => {
                                    handleLabType(v.labName, index, iLabDisplay, v)
                                  }}
                                  onInputChange={(event, inputLabName) => {
                                    if (event != null) {
                                      handleLabType(inputLabName, index, iLabDisplay, labDisplay)
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <InputCheckbox
                                  // disabled={lab.labId === null ? false : true}
                                  disabled
                                  checked={lab.inputSupport === 'SUPPORT' ? true : false}
                                  label={''}
                                  onChange={(e) => {
                                    handleSupportLabType(e.target.checked, index, iLabDisplay)
                                  }}
                                />
                              </TableCell>
                              <TableCell align="center">
                                <IconButton
                                  className={'btn-delete'}
                                  aria-label="delete"
                                  onClick={(e) => {
                                    handleDeleteLabInLabTypesDisplay(iLabDisplay, index)
                                  }}
                                  sx={{ backgroundColor: 'transparent !important', padding: 0 }}
                                >
                                  <img src={icons.btnTrash} alt="trash" style={{ width: 24 }} />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
